import script from "./TableDropdownMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TableDropdownMenu.vue?vue&type=script&setup=true&lang=js"

import "./TableDropdownMenu.vue?vue&type=style&index=0&id=33e51b64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e51b64"]])

export default __exports__